// src/pages/PolitikaPrivatnosti.js

import React from 'react';
import { Link } from 'react-router-dom';

const PolitikaPrivatnosti = () => {
  return (
    <div style={{ padding: '1rem', maxWidth: '700px', margin: '0 auto' }}>
      <h1>Politika privatnosti</h1>

      <p>
        Ova Politika privatnosti objašnjava na koji način <strong>kalkulator-plata.com</strong>
        (u daljem tekstu: “ja” ili “moj sajt”) prikuplja, koristi i štiti informacije koje vi
        (korisnik) ostavljate prilikom korišćenja sajta.
      </p>

      <h2>1. Koje podatke prikupljam</h2>
      <ul>
        <li>
          <strong>Lični podaci:</strong> Kada popunjavate kontakt formu, prikupljam vaše ime, prezime, email
          adresu i ostale podatke koje dobrovoljno ostavite.
        </li>
        <li>
          <strong>Tehnički podaci:</strong> IP adresa, tip pretraživača, operativni sistem i slični podaci
          koji se automatski čuvaju u server logovima.
        </li>
        <li>
          <strong>Kolačići (Cookies):</strong> Koristim kolačiće kako bih poboljšao funkcionalnost sajta i
          analizirao saobraćaj. Možete da onemogućite kolačiće u podešavanjima pretraživača, ali to može
          uticati na rad sajta.
        </li>
      </ul>

      <h2>2. Kako koristim prikupljene podatke</h2>
      <ul>
        <li>
          <strong>Unapređenje sajta i korisničkog iskustva:</strong> Analiziram saobraćaj i ponašanje
          posjetilaca da bih optimizovao interfejs i dodao nove funkcionalnosti.
        </li>
        <li>
          <strong>Komunikacija:</strong> Vaše email adrese koristim za odgovor na upite i slanje važnih obaveštenja.
        </li>
        <li>
          <strong>Oglašavanje:</strong> Ako omogućim prikaz reklama putem Google AdSense-a, dio
          anonimizovanih podataka može biti prosleđen Google-u u svrhe prikaza relevantnih oglasa.
        </li>
      </ul>

      <h2>3. S kim dijelim vaše podatke</h2>
      <ul>
        <li>
          <strong>Google AdSense:</strong> Ako kliknete ili vidite oglas, određeni anonimni podaci
          (anonimizovani ID kolačića) se prosleđuju Google-u radi obračuna prikaza/klika.
        </li>
        <li>
          <strong>Hosting provajder:</strong> Logovi i tehnički podaci mogu biti podeljeni sa provajderom
          hostinga, isključivo radi rješavanja tehničkih problema.
        </li>
        <li>
          <strong>Zakon i regulative:</strong> Ako nadležni organi zahtjevaju podatke po zakonu, moraću da
          ih ispunim.
        </li>
      </ul>

      <h2>4. Kako čuvam podatke</h2>
      <p>
        Primenjujem prikladne tehničke i organizacione mere zaštite (SSL enkripcija, firewall, redovna
        ažuriranja sistema) kako bih sprečio neautorizovan pristup, otkrivanje ili izmjene vaših informacija.
        Podaci se čuvaju onoliko dugo koliko je neophodno da bi se ispunile svrhe navedene u ovoj Politici
        privatnosti ili dok ne zatražite njihovo brisanje.
      </p>

      <h2>5. Kolačići (Cookies)</h2>
      <p>
        Kolačići su mali fajlovi koje vaš pretraživač čuva na uređaju. Mogu se koristiti sledeće vrste kolačića:
      </p>
      <ul>
        <li>
          <strong>Obavezni kolačići:</strong> Neophodni za osnovne funkcionalnosti sajta (npr. sesija,
          bezbednosne provere).
        </li>
        <li>
          <strong>Analitički kolačići:</strong> Prikupljaju anonimne podatke o posjetiocima (npr. Google
          Analytics) za analizu posjeta.
        </li>
        <li>
          <strong>Funkcionalni kolačići:</strong> Pamte vaša podešavanja (npr. jezik, izgled) kako bi se
          poboljšalo korisničko iskustvo.
        </li>
        <li>
          <strong>Marketing kolačići:</strong> Koriste se za personalizaciju reklama (posebno u kombinaciji
          sa AdSense-om). Onemogućavanje kolačića može uticati na rad nekih funkcionalnosti.
        </li>
      </ul>

      <h2>6. Ažuriranja Politike privatnosti</h2>
      <p>
        Ovu Politiku privatnosti mogu povremeno menjati (npr. zbog novih zakona ili funkcionalnosti). Sve
        izmjene će biti objavljene na ovoj stranici s naznakom datuma poslednje revizije.
      </p>

      <p>
        <em>Datum poslednje revizije: 05.06.2025.</em>
      </p>
    </div>
  );
};

export default PolitikaPrivatnosti;
